var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5201 7.21924H8.48116C8.07679 7.25481 7.70046 7.44058 7.42629 7.73993C7.15212 8.03927 7 8.43046 7 8.83639C7 9.24232 7.15212 9.63351 7.42629 9.93286C7.70046 10.2322 8.07679 10.418 8.48116 10.4535H14.3816V23.2996C14.4171 23.704 14.6029 24.0804 14.9023 24.3546C15.2016 24.6287 15.5929 24.7808 15.9988 24.7808C16.4047 24.7808 16.7959 24.6287 17.0953 24.3546C17.3946 24.0804 17.5803 23.704 17.6159 23.2996V10.4535H23.5188C23.9232 10.418 24.2996 10.2322 24.5738 9.93286C24.848 9.63351 25 9.24232 25 8.83639C25 8.43046 24.848 8.03927 24.5738 7.73993C24.2996 7.44058 23.9232 7.25481 23.5188 7.21924H23.5201Z"
  })));
};
export default SvgText;